// Small pill-shaped status badge. Used for matter status, role tier
// (when not using the colored ROLE_BADGE_COLORS variant), document
// kind, etc. Five variants cover everything we need today.

import React from "react";
import { C } from "../constants.js";

export function Badge({ children, variant = "default" }) {
  const styles = {
    default: { background: C.warmGray, color: C.textDark },
    gold: { background: `${C.gold}20`, color: C.goldDim, border: `1px solid ${C.gold}40` },
    success: { background: C.successBg, color: C.success },
    error: { background: C.errorBg, color: C.error },
    navy: { background: `${C.navy}15`, color: C.navy },
  };
  return React.createElement("span", {
    style: { ...styles[variant], padding:"2px 10px", borderRadius:"9999px", fontSize:"12px", fontWeight:600, letterSpacing:"0.025em", whiteSpace:"nowrap" }
  }, children);
}
